import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import getLocale from '../../../i18n/getLocale';

class DrowsinessSchedulesEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      id: this.props.base_id,
      staff_list: [],
      transportation: 0,
      active: 0,
      date_start: this.props.drowsiness_schedule_data.date_start_str,
      date_finish: this.props.drowsiness_schedule_data.date_finish_str,
      name: this.props.drowsiness_schedule_data.name,
      status: this.props.drowsiness_schedule_data.status,
    };

    //bind específico
    this.edit = this.edit.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.date_start === 'undefined' && typeof newProps.drowsiness_schedule_data.date_start !== 'undefined') {
      this.setState({
        id: newProps.drowsiness_schedule_data.id,
        date_start: newProps.drowsiness_schedule_data.date_start_str,
        date_finish: newProps.drowsiness_schedule_data.date_finish_str,
        name: newProps.drowsiness_schedule_data.name,
        status: newProps.drowsiness_schedule_data.status,
      });
    }
    if(Array.isArray(newProps.staff_list)) {
      this.setState({staff_list: newProps.staff_list});
    }
  }
  
  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      name: this.state.name,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/sonolencia', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.edit}> 
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabDadosDaEscala.formulario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabDadosDaEscala.formulario.placeholder.NomeDaEscalaDeSonolencia} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabDadosDaEscala.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start} required maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabDadosDaEscala.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish} required maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
            </div>
          </div>
        </div>
    <div className="row">
      <div className="col-md-12">
      {this.state.status === 'rascunho' ?
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvarEdicao}</button>
        : ''
      }
      </div>
    </div>
  </form>
</div>
    );
  }
}

export default DrowsinessSchedulesEditTab;



// WEBPACK FOOTER //
// ./src/Components/DrowsinessSchedules/Elements/DrowsinessSchedulesEditTab.js